function isInvalidTimeOrder(items, oldIndex, newIndex) {
  if (items[oldIndex].type === "day_name") {
    throw Error(`bad index value (${oldIndex}) in time validation`);
  }
  const time = items[oldIndex].time_in_minutes;
  if (!Number.isInteger(time)) {
    return false;
  }
  return !!(
    invalidTimeBefore(items, oldIndex, newIndex) ||
    invalidTimeAfter(items, oldIndex, newIndex)
  );
}

function invalidTimeBefore(items, oldIndex, newIndex) {
  return findItemWithInvalidTime(items, oldIndex, newIndex, "above");
}

function invalidTimeAfter(items, oldIndex, newIndex) {
  return findItemWithInvalidTime(items, oldIndex, newIndex, "below");
}

function findTimeBefore(items, oldIndex, newIndex) {
  return findItemWithTime(items, oldIndex, newIndex, "above", false);
}

function findTimeAfter(items, oldIndex, newIndex) {
  return findItemWithTime(items, oldIndex, newIndex, "below", false);
}

function findItemWithInvalidTime(items, oldIndex, newIndex, direction) {
  return findItemWithTime(items, oldIndex, newIndex, direction, true);
}

function findItemWithTime(items, oldIndex, newIndex, direction, onlyInvalid) {
  const incrementor = { above: -1, below: 1 }[direction];
  const limit = { above: -1, below: items.length }[direction];
  const time = items[oldIndex].time_in_minutes;
  const compare = {
    above: (a, b) => {
      return a > b;
    },
    below: (a, b) => {
      return a < b;
    },
  }[direction];
  let i = newIndex;
  if (oldIndex < newIndex && direction === "below") {
    i += 1;
  }
  if (oldIndex > newIndex && direction === "above") {
    i -= 1;
  }
  console.log("direction", direction, "i", i, "limit", limit, time, items[i]);
  while (
    i !== limit &&
    items[i] &&
    items[i].type !== "day_name" &&
    items[i].type !== "calendar_note" &&
    items[i].type !== "continuing_calendar_note"
  ) {
    if (
      Number.isInteger(items[i].time_in_minutes) &&
      items[i].time_in_minutes !== time &&
      (!onlyInvalid || compare(items[i].time_in_minutes, time))
    ) {
      return items[i];
    }
    i += incrementor;
  }
  return false;
}

export { isInvalidTimeOrder, findTimeBefore, findTimeAfter };
